import { render } from "./employee_debts_report.vue?vue&type=template&id=61831610"
import script from "./employee_debts_report.vue?vue&type=script&lang=js"
export * from "./employee_debts_report.vue?vue&type=script&lang=js"

import "./employee_debts_report.vue?vue&type=style&index=0&id=61831610&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__